<template>
  <a href="/umoney" @click="click" class="umbacklink umbacklink_new" :class="{'active':active}">
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="16"/>
      <path d="M18 10L12.7071 15.2929C12.3166 15.6834 12.3166 16.3166 12.7071 16.7071L18 22" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg>
    <span class="umbacklink__text">Вернуться</span>
  </a>
</template>

<script>
import { mapState } from 'vuex';

  export default {
    data: ()=>({
      actions: {}
    }),
    props: {
      active: {type: Boolean, default: false}
    },
    computed: {
      ...mapState(['step'])
    },
    methods: {
      click(e) {
        e.preventDefault()
        if (this.active) {
          if (this.step == 2 && !this.actions.step1) {
            this.actions.step1 = true
            this.$store.dispatch('callAction','backToStep1')
          }
          if (this.step == 3 && !this.actions.step2) {
            this.actions.step2 = true
            this.$store.dispatch('callAction','backToStep2')
          }
          this.$store.dispatch('prevStep')
        } else {
          this.$store.commit('setShow', false)
          if (!this.actions.away) {
            this.actions.away = true
            this.$store.dispatch('callAction','hide')
          }
        }
      }
    }
  }
</script>

<style lang="sass">
.umbacklink
  display: flex
  align-items: center
  margin-top: 15px
  padding: 0
  margin-bottom: 23px
  color: colors.$newgray
  font-size: 14px
  line-height: 1.12
  letter-spacing: globalvars.$onespacing
  &__text
    padding-top: 4px
  svg
    margin-right: 8px
    margin-top: 3px
    &, *
      transition: .3s ease-out
    rect
      fill: white
    path
      stroke: colors.$newgray
  &.active svg rect
    fill: colors.$anothersilver
  &_new
    color: colors.$newgray
    font-size: 14px
    line-height: 1.12
    svg
      margin-right: 16px
  @include for-mob
    font-size: 12px
    line-height: 16px
    margin-top: 5px
    margin-bottom: 32px
    svg
      margin-right: 3px
      margin-left: 0
    &_new
      font-size: 14px
      svg
        margin-right: 12px


</style>